import { parseHtmlToPlainText } from '@/shared/utils/html-utils';
import { resolveMessageVariables } from '@/shared/utils/template-variable-utils';

/** A saved template as plain text with every variable filled from `values` (see
 *  `useMessageVariableValues`). Bulk sends skip this and keep the HTML for the server to fill. */
export function resolveQuickReplyText(quickReply: string, values: Record<string, string>): string {
	return resolveMessageVariables(parseHtmlToPlainText(quickReply.trim()), values, {
		blankUnknown: true,
	});
}
